import React from 'react';
import { IconButton, ListItemIcon, Menu, MenuItem } from '@mui/material';
import {
  DeleteBlackIcon,
  MoreIcon,
  MoveToGroupIcon,
  ReloadIcon,
  SettingsIcon
} from '@components/icons/svg-icon.tsx';
import { useTranslation } from 'react-i18next';
import { DevicesActionsProps } from '@modules/digital-signage/model/devices.model';

const DeviceActions: React.FC<DevicesActionsProps> = ({
  row,
  reloadDevice,
  handleDelete,
  handleGroupSettings,
  handleMoveToGroup
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const { t } = useTranslation();

  const handleClickMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        className="p-0! h-5! w-5!"
        disableRipple
        onClick={handleClickMenu}
      >
        <MoreIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        sx={{ minWidth: 200 }}
      >
        <MenuItem
          onClick={() => {
            reloadDevice(row);
            handleCloseMenu();
          }}
        >
          <ListItemIcon
            sx={{
              backgroundColor: 'var(--gray-11)',
              minWidth: '30px !important',
              height: 30,
              borderRadius: '50%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <ReloadIcon strokeOpacity={1} />
          </ListItemIcon>
          {t('reload_device')}
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleGroupSettings(row);
            handleCloseMenu();
          }}
        >
          <ListItemIcon
            sx={{
              backgroundColor: 'var(--gray-11)',
              minWidth: '30px !important',
              height: 30,
              borderRadius: '50%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <SettingsIcon width={22} color="#727475" strokeWidth={2} />
          </ListItemIcon>
          {t('group_settings')}
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleMoveToGroup(row);
            handleCloseMenu();
          }}
        >
          <ListItemIcon
            sx={{
              backgroundColor: 'var(--gray-11)',
              minWidth: '30px !important',
              height: 30,
              borderRadius: '50%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <MoveToGroupIcon className="w-5.25! h-5.25!" />
          </ListItemIcon>
          {t('move_to_group')}
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleDelete(row);
            handleCloseMenu();
          }}
        >
          <ListItemIcon
            sx={{
              backgroundColor: 'var(--gray-11)',
              minWidth: '30px !important',
              height: 30,
              borderRadius: '50%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <DeleteBlackIcon />
          </ListItemIcon>
          {t('delete')}
        </MenuItem>
      </Menu>
    </>
  );
};

export default DeviceActions;
